var version = {
    "name":      "dativery",
    "buildDateCode": "20251129-201539",
    "buildDate": "Sat Nov 29 2025 20:15:39 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20251129-201539",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;